import { render, staticRenderFns } from "./zhuanti-xinxingchengzhenhua.vue?vue&type=template&id=60922da4&"
import script from "./zhuanti-xinxingchengzhenhua.vue?vue&type=script&lang=js&"
export * from "./zhuanti-xinxingchengzhenhua.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports